const twoDigits = (n: number): string => {
  let s = n.toFixed(0);
  if (s.length === 1) {
    s = `0${s}`;
  }
  return s;
};

export default twoDigits;